<template>
  <div id="letDownScreen">
    <div id="letDown">
      <div class="letDownWrap">
        <div class="logoTitle">
          <img class="logo" src="@/assets/images/login/logo.png" alt="">
          <img class="title" src="@/assets/images/login/title_picture.png" alt="">
        </div>
        <div class="letDownBox">
          <div class="title" style="position: relative;height:66px">
            <div style="display: flex; align-items: center;  font-size:25px;margin:15px 0">
                            <span @click="iconBack"
                                  style="display: flex;align-items: center;cursor:pointer;position:absolute;z-index:999">
                                <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
                            </span>
              <div class="title-content" style="width:1024px; position:absolute; left:-24px">
                <div style="text-align:center">{{orgName}}2021-2023年地方青少年足球品牌赛事计划信息收集</div>
              </div>

            </div>
          </div>
          <div class="form-wrap recruitment">
            <vue-scroll>
              <div class="scroll-content">
                <el-form :model="formData" ref="vitaForm" label-width="150px" color="white"
                         size="medium">
                  <div class="border-wrapper" v-for="(item, index) in formData.coachList" :key="index">
                    <!-- u-13 -->
                    <fieldset class="qualification-form-fieldset">
                      <legend>赛事-{{index+1}}</legend>
                      <el-row >
                        <el-col :span="12">
                          <el-form-item label="参赛年龄段(可多选)" :prop="`coachList.${index}.age`" :rules="[requiredItem('参赛年龄段')]">
                            <el-select class="w_100" v-model="item.age" multiple placeholer="请选择参赛年龄段">
                              <el-option label="U12" value="U12"></el-option>
                              <el-option label="U13" value="U13"></el-option>
                              <el-option label="U14" value="U14"></el-option>
                              <el-option label="U15" value="U15"></el-option>
                              <el-option label="U16" value="U16"></el-option>
                              <el-option label="U17" value="U17"></el-option>
                              <el-option label="U18" value="U18"></el-option>
                              <el-option label="U19" value="U19"></el-option>
                              <el-option label="U20" value="U20"></el-option>
                              <el-option label="U21" value="U21"></el-option>
                              <el-option label="U22" value="U22"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="赛事名称" :prop="`coachList.${index}.matchName`" :rules="[requiredItem('姓名')]">
                            <el-input v-model="item.matchName" placeholder="请输入赛事名称"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="主办单位" :prop="`coachList.${index}.sponsor`" :rules="[requiredItem('承办单位')]">
                            <el-input v-model.trim="item.sponsor" placeholder="请输入主办单位"></el-input>
                          </el-form-item>
                        </el-col>
  
                        <el-col :span="12">
                          <el-form-item label="承办单位">
                            <el-input v-model.trim="item.undertake" placeholder="请输入承办单位"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="办赛开始日期" :prop="`coachList.${index}.matchStart`"
                            :rules="{required: true, validator: (rule, value, callback) => {validateMonth(rule, value, callback)}, trigger: `change`}">
                            <el-date-picker
                              v-model="item.matchStart"
                              type="date"
                              @focus="datePickerOfStart(item)"
                              :picker-options="pickerOptionsStart"
                              :value-format="'yyyy-MM-dd'"
                              style="width:305px"
                              placeholder="选择日期">
                              <!--pickerOptionsStart-->
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="办赛截止日期" :prop="`coachList.${index}.matchEnd`"
                            :rules="{required: true, validator: (rule, value, callback) => {validateMonth(rule, value, callback)}, trigger: `change`}">
                            <el-date-picker
                              v-model="item.matchEnd"
                              type="date"
                              @focus="datePickerOfEnd(item)"
                              :picker-options="pickerOptionsEnd"
                              :value-format="'yyyy-MM-dd'"
                              style="width:305px"
                              placeholder="选择日期">
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国内参赛队伍数量" :prop="`coachList.${index}.domesticTeamNum`" :rules="[requiredItem('国内参赛队伍数量'),numberRequired() ]">
                            <el-input v-model.number="item.domesticTeamNum" placeholder="请输入国内参赛队伍数量"></el-input>
                          </el-form-item>
                        </el-col>
    
                        <el-col :span="12">
                          <el-form-item label="国外参赛队伍数量" :prop="`coachList.${index}.foreignTeamNum`" :rules="[requiredItem('国外参赛队伍数量'),numberRequired() ]">
                            <el-input v-model.number="item.foreignTeamNum" placeholder="请输入国外参赛队伍数量"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="11">
                          <el-form-item label="总费用预算" :prop="`coachList.${index}.totalCost`" :rules="[requiredItem('总费用预算'),numberRequired() ]">
                            <el-input v-model.number="item.totalCost" placeholder="请输入总费用预算"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1" style="padding: 10px;"><span>元</span></el-col>
                        <el-col :span="11">
                          <el-form-item label="往届赛事总费用" :prop="`coachList.${index}.totalCostPrevious`" :rules="[requiredItem('往届赛事总费用'),numberRequired() ]">
                            <el-input v-model.number="item.totalCostPrevious" placeholder="请输入往届赛事总费用"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1" style="padding: 10px;"><span>元</span></el-col>
                      </el-row>
  
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人" :prop="`coachList.${index}.linkMan`" :rules="[requiredItem('联系人')]">
                            <el-input v-model.trim="item.linkMan" placeholder="请输入联系人"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="联系电话" :prop="`coachList.${index}.phone`" :rules="[requiredItem('联系电话'),phoneRequired() ]">
                            <el-input v-model.trim="item.phone" placeholder="请输入联系电话"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <el-form-item label="办赛地点" :prop="`coachList.${index}.address`" :rules="[requiredItem('办赛地点')]">
                            <el-input v-model.trim="item.address" placeholder="请输入办赛地点"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <el-form-item label="办赛理念" :prop="`coachList.${index}.matchConcept`" :rules="[requiredItem('办赛理念')]">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model.trim="item.matchConcept" placeholder="请输入办赛理念"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <el-form-item label="往届赛事信息" :prop="`coachList.${index}.previousInfo`" :rules="[requiredItem('往届赛事信息')]">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model.trim="item.previousInfo" placeholder="请输入往届赛事信息（赛事届数、年龄段、国内国外参赛队伍数量）"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </fieldset>

                    <div class="btns-wrapper">
                      <el-button v-if="!(formData.coachList.length === 99) && (index + 1 >= formData.coachList.length)" type="primary"
                                 icon="el-icon-plus" circle
                                 @click="addNewCoach(index)"
                      ></el-button>
                      <el-button
                        v-if="!(formData.coachList.length ===1)"
                        type="warning"
                        icon="el-icon-delete"
                        circle
                        @click="deleteCoach(index)"></el-button>
                    </div>
                  </div>


                </el-form>
              </div>
            </vue-scroll>
          </div>
          <div class="btns">
            <el-button type="primary" @click="checkForm">提交
            </el-button>
            <el-button type="danger" @click="cancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <yioks-tips :showTip="tipsFlag" tipMsg="信息收集只能提交一次，提交以后不能更改，请确认是否提交？" :loading="repeatSubmit" @callback="hideTipsDialog" style="text-align: center;"></yioks-tips>
    <yioks-tips :showTip="cancelFlag" tipMsg="请确认取消提交？" @callback="goBack"></yioks-tips>
  </div>
</template>

<script>
  import 'vue-awesome/icons/regular/arrow-alt-circle-left'
  import { ops } from '@/utils/scrollIndialog'
  import { requiredItem, numberRequired, phoneRequired, isIdNumber } from '@/assets/js/formRules'
  import { postYouthMatch } from "@/api/tempApi";
  import qs from 'qs'

  export default {
    name: 'YouthMatch',

    data () {
      const validateMonth = (rule, value, callback) => {
        if (!value) {
          callback(new Error("请选择日期"));
        } else {
          callback();
        }
      };
      return {
        validateMonth,
        requiredItem,     // 表单校验方法
        numberRequired,   // 表单校验方法
        phoneRequired,    // 表单校验方法
        isIdNumber,
        staticUrl: '/uploads/templateFile/报名表.xlsx',
        ops,
        tipsFlag: false,    // 页面确认提交提示
        repeatSubmit: false,  // 重复提交提示
        cancelFlag: false,  // 页面取消提示
        pickerStart: '',
        pickerEnd: '',
        formData: {
          coachList: [
            {
              age:'',
              matchName:'',
              matchConcept:'',
              sponsor: '',
              undertake: '',
              matchStart: '',
              matchEnd: '',
              address: '',
              domesticTeamNum: '',
              foreignTeamNum: '',
              totalCost: '',
              totalCostPrevious: '',
              previousInfo: '',
              linkMan: '',
              phone: '',
            }
          ]
        },
        Inforules: {

        },
      }
    },

    computed: {
      pickerOptionsEnd() {
        const pickerStart = this.pickerStart;
        if(pickerStart) {
          return {
            disabledDate(time) {
              return time.getTime() < Date.parse(pickerStart);
            },
          }
        } else {
          return {
            disabledDate(time) {
              return false ;
            },
          }
        }
      },
      pickerOptionsStart() {
        const pickerEnd = this.pickerEnd;
        if(pickerEnd) {
          return {
            disabledDate(time) {
              return time.getTime() > Date.parse(pickerEnd);
            },
          }
        } else {
          return {
            disabledDate(time) {
              return false ;
            },
          }
        }
    
      },
      orgName () {
        const { orgName } = this.$route.query
        if (!orgName) {
          console.error('orgName error!~')
          return ''
        } else {
          return orgName
        }
      },

      orgUuid() {
        const { orgUuid } = this.$route.query
        if (!orgUuid) {
          console.error('orgUuid error!~')
          return ''
        } else {
          return orgUuid
        }
      },

      password() {
        const { password } = this.$route.query
        if (!password) {
          console.error('password error!~')
          return ''
        } else {
          return password
        }
      }
    },

    components: {
      // 'v-icon': () => import('vue-awesome/components/Icon'),
      'yioks-tips': () => import('@/components/YioksTip')
    },


    methods: {
      datePickerOfStart(val) {
        const { matchEnd } = val;
        if(matchEnd){
          this.pickerEnd = matchEnd;
        } else {
          this.pickerEnd = null;
        }
      },
      datePickerOfEnd(val) {
        const { matchStart } = val;
        if(matchStart){
          this.pickerStart = matchStart;
        } else {
          this.pickerStart = null;
        }
      },
      iconBack () {
        this.$router.go(-1)
      },
      findProcess () {
        window.open(this.staticUrl)
      },

      checkForm () {
        this.$refs['vitaForm'].validate((valid) => {
          if (valid) {
            this.tipsFlag = true
          } else {
            console.error('error submit validate!!')
            return false
          }
        })
      },

      hideTipsDialog (bool) {
        if (bool) {
          if (!this.repeatSubmit) {
            this.repeatSubmit = true;
            const { coachList } = this.formData
            const organUuid= this.orgUuid;
            const matchList = coachList.map(item => {
              const aimObj = {
                ...item,
                age: item.age.join(',')
              }
              return aimObj;
            })
            const submitData = {
              matchList,
              organUuid,
              verificationCode: this.password
            }
            postYouthMatch(submitData).then(res => {
              if (res.code){
                this.$message.error(res.msg);
                return
              }
              this.$message.success('信息提交成功')
              this.tipsFlag = false;
              this.$router.go(-1);
              this.repeatSubmit = false;
              this.$refs['vitaForm'].clearValidate();
            }).catch(err => {
              console.error(err);
              this.repeatSubmit = false;
              this.tipsFlag = false;
            })
          }
        } else {
          this.repeatSubmit = false
          this.tipsFlag = false
        }
      },
      cancel () {
        this.cancelFlag = true
      },
      goBack (isSure) {
        if (isSure) {
          this.$router.go(-1)
        }
        this.cancelFlag = false
      },
      /* 新增机构 */
      addNewCoach(index) {
        const newCoach = {
          age:'',
          matchName:'',
          matchConcept:'',
          sponsor: '',
          undertake: '',
          matchStart: '',
          matchEnd: '',
          address: '',
          domesticTeamNum: '',
          foreignTeamNum: '',
          totalCost: '',
          totalCostPrevious: '',
          previousInfo: '',
          linkMan: '',
          phone: '',
        };
        const { coachList } = this.formData;
        coachList.push(newCoach);
        this.$set(this.formData, 'coachList', coachList)
      },
      deleteCoach(index) {
        const { coachList } = this.formData;
        coachList.splice(index, 1)
        this.$set(this.formData, 'coachList', coachList)
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  #letDownScreen {
    width: 100%;
    height: 100%;
    font-size: 14px;

    #letDown {
      height: calc(100% - 60px);
      display: flex;
      justify-content: center;
      user-select: none;

      .letDownWrap {
        width: 1024px;
        padding: 95px 0 0;
        display: flex;
        flex-direction: column;

        .logoTitle {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 0 50px 0;

          .logo {
            width: 120px;
            height: 120px;
            margin: 0 15px 0 0;
          }
        }

        .letDownBox {
          align-self: center;
          width: 1024px;
          /*width: 1150px;*/
          /*height: 550px;*/
          height: 610px;
          padding: 0 25px;
          background-color: $black_color;
          box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
          position: relative;
          color: $color_white;

          .title {
            display flex
            justify-content space-between
            align-items center
            margin: 10px 0 10px 0;
            border-bottom: 2px solid;
            padding-bottom: 10px;

            h2 {
              font-size: 25px;
            }
          }

          .form-wrap {

            height: 460px;

            .qualification-form-fieldset {
              margin: 0 0 20px 0;
              padding: 10px 10px 0;
              border: 1px solid $color_white;

              .code {
                width: 150px;
                margin-left: 20px;
                display: inline-block;
                line-height: 1.5;
                white-space: nowrap;
                cursor: pointer;
                text-align: center;
                outline: none;
                border-radius 4px
                padding: 8px 16px;
                background-color: $color_suc;
              }

              .waittime {
                background-color: #909399
              }
            }
          }

          .btns {
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }

  .yioks-btn
    background-color: #4CD964

  .back-icon
    width 24px
    height 24px

  .scroll-content {
    margin 0 15px
    padding-right: 10px
  }

  .w_45 {
    width 45%
  }

  .w_100 {
    width 100%
  }

  .double-line {
    width 60%
  }

  .el-upload__tip {
    color #FFFFFF
    position relative

    .download-box {
      position absolute
      top -35px
      left 90px
      color #4cd964
      text-decoration underline
      cursor pointer
    }
  }

  .example {
    position absolute
    right -37px
    font-size 16px
    top 10px

    .intro {
      text-decoration underline
      cursor pointer
      color #4cd964
    }

    .showExample {
      display none
      position absolute
      width 400px
      left -200px
      z-index 999
      background-color white

      .nameExample {
        /*text-align center*/
        color black
        text-align center
      }

      .img {
        padding 0 20px 10px

        img {
          width 100%
          height 100%
        }
      }

      &::before {
        content ''
        position absolute
        top -8px
        left 200px
        border-bottom 8px solid white
        border-right 8px solid transparent
        border-left 8px solid transparent
      }
    }

    .showExampledouble {
      display none
      position absolute
      width 600px
      left -300px
      z-index 999
      background-color white

      .nameExample {
        /*text-align center*/
        color black
        text-align center
      }

      .img {
        display flex
        padding 0 20px 10px

        .section {
          .l_title {
            font-size 14px
            color black
            text-align center
          }

          img {
            width: 100%
            /*height 100%*/
          }
        }
      }

      &::before {
        content ''
        position absolute
        top -8px
        left 300px
        border-bottom 8px solid white
        border-right 8px solid transparent
        border-left 8px solid transparent
      }
    }

    &:hover {
      .showExample {
        display: block
      }

      .showExampledouble {
        display: block
      }
    }

  }

  .w_d_100 {
    width 87%
    margin-left 30px
  }

  .w_l_100 {
    width: 110%
  }

  .w_70 {
    width 70%
  }

  .w_80 {
    width 80%
  }

  .w_90 {
    width 90%
  }

  .w_l_120 {
    width 120%
  }

  .border-wrapper {
    border 1px solid #FFFFFF
    padding 5px 10px
    position: relative
    padding-bottom 50px
    margin-bottom 10px
    &:last-child {
      margin-bottom 0
    }
    .btns-wrapper {
      width 120px
      height 30px
      display flex
      justify-content space-around
      align-items center
      position absolute
      bottom 15px
      left calc(50% - 60px)
    }
  }

  .w140px {
    width 140px
  }
</style>
<style lang="stylus">
  .form-wrap {
    .el-form-item__label {
      color: #FFFFFF;
    }

    .continue_education {
      width 53%
      margin-left 23px
    }

    .vita-edu-row {
      .el-range-separator {
        padding: 0;
      }

      .el-date-editor {
        width 323px
      }

      .orgPlace {
        width 100%
      }
    }
    $width = 306px;
    /*.birthday {
      .el-date-editor {
        width: $width;
      }
    }*/

    .gender, .national {
      .el-select {
        width: $width;
      }
    }

  }

  .recruitment {
    .el-icon-document {
      color #FFFFFF
    }

    .el-upload-list__item-name {
      color #FFFFFF
    }

    .el-radio__label {
      color #FFFFFF
    }
  }
</style>
